import type { Team } from '@bracketblitz/shared-types';

// ─── 2026 NCAA Tournament Teams ───────────────────────────────────────────────
// Official bracket from Selection Sunday, March 15 2026
// No. 1 seeds: Duke (East), Arizona (West), Michigan (Midwest), Florida (South)
// 68 teams total: 64 bracket spots + 4 First Four play-in teams
// shortName: manually curated — never split(' ')[0]

const blankResume: any = {
  netRanking: null,
  sosRanking: null,
  quadrantRecord: {
    q1: { wins: 0, losses: 0 },
    q2: { wins: 0, losses: 0 },
    q3: { wins: 0, losses: 0 },
    q4: { wins: 0, losses: 0 },
  },
};

export const teams: Team[] = [
  // ── EAST REGION ─────────────────────────────────────────────
  {
    id: 'team-duke',
    name: 'Duke',
    shortName: 'Duke',
    mascot: 'Blue Devils',
    conference: 'ACC',
    seed: 1,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/150.png',
    primaryColor: '#003087',
    secondaryColor: '#FFFFFF',
    record: { wins: 32, losses: 2 },
    resume: { ...blankResume, netRanking: 1 },
  },
  {
    id: 'team-connecticut',
    name: 'UConn',
    shortName: 'UConn',
    mascot: 'Huskies',
    conference: 'Big East',
    seed: 2,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/41.png',
    primaryColor: '#002868',
    secondaryColor: '#FFFFFF',
    record: { wins: 29, losses: 5 },
    resume: { ...blankResume, netRanking: 7 },
  },
  {
    id: 'team-michigan-st',
    name: 'Michigan St.',
    shortName: 'Mich. St.',
    mascot: 'Spartans',
    conference: 'Big Ten',
    seed: 3,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/127.png',
    primaryColor: '#18453B',
    secondaryColor: '#FFFFFF',
    record: { wins: 25, losses: 7 },
    resume: { ...blankResume, netRanking: 11 },
  },
  {
    id: 'team-kansas',
    name: 'Kansas',
    shortName: 'Kansas',
    mascot: 'Jayhawks',
    conference: 'Big 12',
    seed: 4,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2305.png',
    primaryColor: '#0051A5',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 10 },
    resume: { ...blankResume, netRanking: 15 },
  },
  {
    id: 'team-st-johns',
    name: 'St. John\'s',
    shortName: 'St. John\'s',
    mascot: 'Red Storm',
    conference: 'Big East',
    seed: 5,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2599.png',
    primaryColor: '#CC0000',
    secondaryColor: '#FFFFFF',
    record: { wins: 28, losses: 6 },
    resume: { ...blankResume, netRanking: 13 },
  },
  {
    id: 'team-louisville',
    name: 'Louisville',
    shortName: 'Louisville',
    mascot: 'Cardinals',
    conference: 'ACC',
    seed: 6,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/97.png',
    primaryColor: '#AD0000',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 10 },
    resume: { ...blankResume, netRanking: 22 },
  },
  {
    id: 'team-ucla',
    name: 'UCLA',
    shortName: 'UCLA',
    mascot: 'Bruins',
    conference: 'Big Ten',
    seed: 7,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/26.png',
    primaryColor: '#2D68C4',
    secondaryColor: '#F2A900',
    record: { wins: 23, losses: 11 },
    resume: { ...blankResume, netRanking: 28 },
  },
  {
    id: 'team-ohio-st',
    name: 'Ohio St.',
    shortName: 'Ohio St.',
    mascot: 'Buckeyes',
    conference: 'Big Ten',
    seed: 8,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/194.png',
    primaryColor: '#BB0000',
    secondaryColor: '#FFFFFF',
    record: { wins: 21, losses: 12 },
    resume: { ...blankResume, netRanking: 31 },
  },
  {
    id: 'team-tcu',
    name: 'TCU',
    shortName: 'TCU',
    mascot: 'Horned Frogs',
    conference: 'Big 12',
    seed: 9,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2628.png',
    primaryColor: '#4D1979',
    secondaryColor: '#FFFFFF',
    record: { wins: 22, losses: 11 },
    resume: { ...blankResume, netRanking: 36 },
  },
  {
    id: 'team-ucf',
    name: 'UCF',
    shortName: 'UCF',
    mascot: 'Knights',
    conference: 'Big 12',
    seed: 10,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2116.png',
    primaryColor: '#000000',
    secondaryColor: '#FFC904',
    record: { wins: 21, losses: 11 },
    resume: { ...blankResume, netRanking: 42 },
  },
  {
    id: 'team-south-florida',
    name: 'South Florida',
    shortName: 'USF',
    mascot: 'Bulls',
    conference: 'AAC',
    seed: 11,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/58.png',
    primaryColor: '#006747',
    secondaryColor: '#FFFFFF',
    record: { wins: 25, losses: 8 },
    resume: { ...blankResume, netRanking: 45 },
  },
  {
    id: 'team-northern-iowa',
    name: 'Northern Iowa',
    shortName: 'N. Iowa',
    mascot: 'Panthers',
    conference: 'MVC',
    seed: 12,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2272.png',
    primaryColor: '#4B116F',
    secondaryColor: '#FFCD00',
    record: { wins: 23, losses: 12 },
    resume: { ...blankResume, netRanking: 72 },
  },
  {
    id: 'team-cal-baptist',
    name: 'Cal Baptist',
    shortName: 'Cal Baptist',
    mascot: 'Lancers',
    conference: 'WAC',
    seed: 13,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2856.png',
    primaryColor: '#002868',
    secondaryColor: '#FFFFFF',
    record: { wins: 25, losses: 8 },
    resume: { ...blankResume, netRanking: 98 },
  },
  {
    id: 'team-north-dakota-st',
    name: 'North Dakota St.',
    shortName: 'NDSU',
    mascot: 'Bison',
    conference: 'Summit',
    seed: 14,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2449.png',
    primaryColor: '#006633',
    secondaryColor: '#FFC82E',
    record: { wins: 27, losses: 7 },
    resume: { ...blankResume, netRanking: 115 },
  },
  {
    id: 'team-furman',
    name: 'Furman',
    shortName: 'Furman',
    mascot: 'Paladins',
    conference: 'SoCon',
    seed: 15,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/231.png',
    primaryColor: '#582C83',
    secondaryColor: '#FFFFFF',
    record: { wins: 22, losses: 12 },
    resume: { ...blankResume, netRanking: 142 },
  },
  {
    id: 'team-siena',
    name: 'Siena',
    shortName: 'Siena',
    mascot: 'Saints',
    conference: 'MAAC',
    seed: 16,
    region: 'East',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2561.png',
    primaryColor: '#006A4D',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 11 },
    resume: { ...blankResume, netRanking: 180 },
  },

  // ── WEST REGION ─────────────────────────────────────────────
  {
    id: 'team-arizona',
    name: 'Arizona',
    shortName: 'Arizona',
    mascot: 'Wildcats',
    conference: 'Big 12',
    seed: 1,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/12.png',
    primaryColor: '#AB0520',
    secondaryColor: '#0C234B',
    record: { wins: 32, losses: 2 },
    resume: { ...blankResume, netRanking: 3 },
  },
  {
    id: 'team-purdue',
    name: 'Purdue',
    shortName: 'Purdue',
    mascot: 'Boilermakers',
    conference: 'Big Ten',
    seed: 2,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2509.png',
    primaryColor: '#CFB991',
    secondaryColor: '#000000',
    record: { wins: 27, losses: 8 },
    resume: { ...blankResume, netRanking: 9 },
  },
  {
    id: 'team-gonzaga',
    name: 'Gonzaga',
    shortName: 'Gonzaga',
    mascot: 'Bulldogs',
    conference: 'WCC',
    seed: 3,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2250.png',
    primaryColor: '#002469',
    secondaryColor: '#FFFFFF',
    record: { wins: 30, losses: 3 },
    resume: { ...blankResume, netRanking: 6 },
  },
  {
    id: 'team-arkansas',
    name: 'Arkansas',
    shortName: 'Arkansas',
    mascot: 'Razorbacks',
    conference: 'SEC',
    seed: 4,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/8.png',
    primaryColor: '#9D2235',
    secondaryColor: '#FFFFFF',
    record: { wins: 26, losses: 8 },
    resume: { ...blankResume, netRanking: 16 },
  },
  {
    id: 'team-wisconsin',
    name: 'Wisconsin',
    shortName: 'Wisconsin',
    mascot: 'Badgers',
    conference: 'Big Ten',
    seed: 5,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/275.png',
    primaryColor: '#C5050C',
    secondaryColor: '#FFFFFF',
    record: { wins: 24, losses: 10 },
    resume: { ...blankResume, netRanking: 18 },
  },
  {
    id: 'team-byu',
    name: 'BYU',
    shortName: 'BYU',
    mascot: 'Cougars',
    conference: 'Big 12',
    seed: 6,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/252.png',
    primaryColor: '#002E5D',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 11 },
    resume: { ...blankResume, netRanking: 24 },
  },
  {
    id: 'team-miami-fl',
    name: 'Miami (FL)',
    shortName: 'Miami FL',
    mascot: 'Hurricanes',
    conference: 'ACC',
    seed: 7,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2390.png',
    primaryColor: '#005030',
    secondaryColor: '#F47321',
    record: { wins: 25, losses: 8 },
    resume: { ...blankResume, netRanking: 30 },
  },
  {
    id: 'team-villanova',
    name: 'Villanova',
    shortName: 'Villanova',
    mascot: 'Wildcats',
    conference: 'Big East',
    seed: 8,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/222.png',
    primaryColor: '#003E7E',
    secondaryColor: '#FFFFFF',
    record: { wins: 24, losses: 8 },
    resume: { ...blankResume, netRanking: 34 },
  },
  {
    id: 'team-utah-st',
    name: 'Utah St.',
    shortName: 'Utah St.',
    mascot: 'Aggies',
    conference: 'MWC',
    seed: 9,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/328.png',
    primaryColor: '#00263A',
    secondaryColor: '#8B7355',
    record: { wins: 28, losses: 6 },
    resume: { ...blankResume, netRanking: 27 },
  },
  {
    id: 'team-missouri',
    name: 'Missouri',
    shortName: 'Missouri',
    mascot: 'Tigers',
    conference: 'SEC',
    seed: 10,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/142.png',
    primaryColor: '#F1B82D',
    secondaryColor: '#000000',
    record: { wins: 20, losses: 12 },
    resume: { ...blankResume, netRanking: 48 },
  },
  { // First Four
    id: 'team-texas',
    name: 'Texas',
    shortName: 'Texas',
    mascot: 'Longhorns',
    conference: 'SEC',
    seed: 11,
    region: 'West',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/251.png',
    primaryColor: '#BF5700',
    secondaryColor: '#FFFFFF',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
  { // First Four
    id: 'team-nc-state',
    name: 'NC State',
    shortName: 'NC State',
    mascot: 'Wolfpack',
    conference: 'ACC',
    seed: 11,
    region: 'West',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/152.png',
    primaryColor: '#CC0000',
    secondaryColor: '#FFFFFF',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
  {
    id: 'team-high-point',
    name: 'High Point',
    shortName: 'High Point',
    mascot: 'Panthers',
    conference: 'Big South',
    seed: 12,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2272.png',
    primaryColor: '#4B116F',
    secondaryColor: '#FFFFFF',
    record: { wins: 30, losses: 4 },
    resume: { ...blankResume, netRanking: 88 },
  },
  {
    id: 'team-hawaii',
    name: 'Hawaii',
    shortName: 'Hawai\'i',
    mascot: 'Rainbow Warriors',
    conference: 'Big West',
    seed: 13,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/62.png',
    primaryColor: '#007030',
    secondaryColor: '#FFFFFF',
    record: { wins: 24, losses: 8 },
    resume: { ...blankResume, netRanking: 105 },
  },
  {
    id: 'team-kennesaw-st',
    name: 'Kennesaw St.',
    shortName: 'Kennesaw',
    mascot: 'Owls',
    conference: 'ASUN',
    seed: 14,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/338.png',
    primaryColor: '#FDBB30',
    secondaryColor: '#000000',
    record: { wins: 21, losses: 13 },
    resume: { ...blankResume, netRanking: 155 },
  },
  {
    id: 'team-queens',
    name: 'Queens',
    shortName: 'Queens',
    mascot: 'Royals',
    conference: 'ASUN',
    seed: 15,
    region: 'West',
    logo: '',
    primaryColor: '#582C83',
    secondaryColor: '#FFFFFF',
    record: { wins: 21, losses: 13 },
    resume: { ...blankResume, netRanking: 195 },
  },
  {
    id: 'team-liu',
    name: 'LIU',
    shortName: 'LIU',
    mascot: 'Sharks',
    conference: 'NEC',
    seed: 16,
    region: 'West',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2350.png',
    primaryColor: '#002B5C',
    secondaryColor: '#FFFFFF',
    record: { wins: 24, losses: 10 },
    resume: { ...blankResume, netRanking: 225 },
  },

  // ── SOUTH REGION ─────────────────────────────────────────────
  {
    id: 'team-florida',
    name: 'Florida',
    shortName: 'Florida',
    mascot: 'Gators',
    conference: 'SEC',
    seed: 1,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/57.png',
    primaryColor: '#0021A5',
    secondaryColor: '#FA4616',
    record: { wins: 26, losses: 7 },
    resume: { ...blankResume, netRanking: 4 },
  },
  {
    id: 'team-houston',
    name: 'Houston',
    shortName: 'Houston',
    mascot: 'Cougars',
    conference: 'Big 12',
    seed: 2,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/248.png',
    primaryColor: '#C8102E',
    secondaryColor: '#FFFFFF',
    record: { wins: 28, losses: 6 },
    resume: { ...blankResume, netRanking: 5 },
  },
  {
    id: 'team-illinois',
    name: 'Illinois',
    shortName: 'Illinois',
    mascot: 'Fighting Illini',
    conference: 'Big Ten',
    seed: 3,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/356.png',
    primaryColor: '#13294B',
    secondaryColor: '#E84A27',
    record: { wins: 24, losses: 8 },
    resume: { ...blankResume, netRanking: 10 },
  },
  {
    id: 'team-nebraska',
    name: 'Nebraska',
    shortName: 'Nebraska',
    mascot: 'Cornhuskers',
    conference: 'Big Ten',
    seed: 4,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/158.png',
    primaryColor: '#E41C38',
    secondaryColor: '#FFFFFF',
    record: { wins: 26, losses: 6 },
    resume: { ...blankResume, netRanking: 14 },
  },
  {
    id: 'team-vanderbilt',
    name: 'Vanderbilt',
    shortName: 'Vandy',
    mascot: 'Commodores',
    conference: 'SEC',
    seed: 5,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/238.png',
    primaryColor: '#866D4B',
    secondaryColor: '#000000',
    record: { wins: 26, losses: 8 },
    resume: { ...blankResume, netRanking: 20 },
  },
  {
    id: 'team-north-carolina',
    name: 'North Carolina',
    shortName: 'UNC',
    mascot: 'Tar Heels',
    conference: 'ACC',
    seed: 6,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/153.png',
    primaryColor: '#4B9CD3',
    secondaryColor: '#FFFFFF',
    record: { wins: 24, losses: 8 },
    resume: { ...blankResume, netRanking: 23 },
  },
  {
    id: 'team-saint-marys',
    name: 'Saint Mary\'s',
    shortName: 'St. Mary\'s',
    mascot: 'Gaels',
    conference: 'WCC',
    seed: 7,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2608.png',
    primaryColor: '#002868',
    secondaryColor: '#BA0C2F',
    record: { wins: 27, losses: 5 },
    resume: { ...blankResume, netRanking: 21 },
  },
  {
    id: 'team-clemson',
    name: 'Clemson',
    shortName: 'Clemson',
    mascot: 'Tigers',
    conference: 'ACC',
    seed: 8,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/228.png',
    primaryColor: '#F56600',
    secondaryColor: '#522D80',
    record: { wins: 24, losses: 10 },
    resume: { ...blankResume, netRanking: 32 },
  },
  {
    id: 'team-iowa',
    name: 'Iowa',
    shortName: 'Iowa',
    mascot: 'Hawkeyes',
    conference: 'Big Ten',
    seed: 9,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2294.png',
    primaryColor: '#FFCD00',
    secondaryColor: '#000000',
    record: { wins: 21, losses: 12 },
    resume: { ...blankResume, netRanking: 39 },
  },
  {
    id: 'team-texas-am',
    name: 'Texas A&M',
    shortName: 'Texas A&M',
    mascot: 'Aggies',
    conference: 'SEC',
    seed: 10,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/245.png',
    primaryColor: '#500000',
    secondaryColor: '#FFFFFF',
    record: { wins: 21, losses: 11 },
    resume: { ...blankResume, netRanking: 44 },
  },
  {
    id: 'team-vcu',
    name: 'VCU',
    shortName: 'VCU',
    mascot: 'Rams',
    conference: 'A-10',
    seed: 11,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2670.png',
    primaryColor: '#000000',
    secondaryColor: '#FDBB30',
    record: { wins: 27, losses: 7 },
    resume: { ...blankResume, netRanking: 40 },
  },
  {
    id: 'team-mcneese',
    name: 'McNeese',
    shortName: 'McNeese',
    mascot: 'Cowboys',
    conference: 'Southland',
    seed: 12,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2377.png',
    primaryColor: '#005DAA',
    secondaryColor: '#FFC72C',
    record: { wins: 28, losses: 5 },
    resume: { ...blankResume, netRanking: 62 },
  },
  {
    id: 'team-troy',
    name: 'Troy',
    shortName: 'Troy',
    mascot: 'Trojans',
    conference: 'Sun Belt',
    seed: 13,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2653.png',
    primaryColor: '#8B0000',
    secondaryColor: '#FFFFFF',
    record: { wins: 22, losses: 11 },
    resume: { ...blankResume, netRanking: 128 },
  },
  {
    id: 'team-penn',
    name: 'Penn',
    shortName: 'Penn',
    mascot: 'Quakers',
    conference: 'Ivy',
    seed: 14,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/219.png',
    primaryColor: '#011F5B',
    secondaryColor: '#FFFFFF',
    record: { wins: 18, losses: 11 },
    resume: { ...blankResume, netRanking: 148 },
  },
  {
    id: 'team-idaho',
    name: 'Idaho',
    shortName: 'Idaho',
    mascot: 'Vandals',
    conference: 'Big Sky',
    seed: 15,
    region: 'South',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/70.png',
    primaryColor: '#B3A369',
    secondaryColor: '#000000',
    record: { wins: 21, losses: 14 },
    resume: { ...blankResume, netRanking: 188 },
  },
  { // First Four
    id: 'team-prairie-view',
    name: 'Prairie View A&M',
    shortName: 'Prairie View',
    mascot: 'Panthers',
    conference: 'SWAC',
    seed: 16,
    region: 'South',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2504.png',
    primaryColor: '#472B91',
    secondaryColor: '#FFFFFF',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
  { // First Four
    id: 'team-lehigh',
    name: 'Lehigh',
    shortName: 'Lehigh',
    mascot: 'Mountain Hawks',
    conference: 'Patriot',
    seed: 16,
    region: 'South',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2350.png',
    primaryColor: '#653600',
    secondaryColor: '#FFFFFF',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },

  // ── MIDWEST REGION ─────────────────────────────────────────────
  {
    id: 'team-michigan',
    name: 'Michigan',
    shortName: 'Michigan',
    mascot: 'Wolverines',
    conference: 'Big Ten',
    seed: 1,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/130.png',
    primaryColor: '#00274C',
    secondaryColor: '#FFCB05',
    record: { wins: 31, losses: 3 },
    resume: { ...blankResume, netRanking: 2 },
  },
  {
    id: 'team-iowa-st',
    name: 'Iowa St.',
    shortName: 'Iowa St.',
    mascot: 'Cyclones',
    conference: 'Big 12',
    seed: 2,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/66.png',
    primaryColor: '#C8102E',
    secondaryColor: '#F1BE48',
    record: { wins: 27, losses: 7 },
    resume: { ...blankResume, netRanking: 8 },
  },
  {
    id: 'team-virginia',
    name: 'Virginia',
    shortName: 'Virginia',
    mascot: 'Cavaliers',
    conference: 'ACC',
    seed: 3,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/258.png',
    primaryColor: '#232D4B',
    secondaryColor: '#F84C1E',
    record: { wins: 29, losses: 5 },
    resume: { ...blankResume, netRanking: 12 },
  },
  {
    id: 'team-alabama',
    name: 'Alabama',
    shortName: 'Alabama',
    mascot: 'Crimson Tide',
    conference: 'SEC',
    seed: 4,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/333.png',
    primaryColor: '#9E1B32',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 9 },
    resume: { ...blankResume, netRanking: 17 },
  },
  {
    id: 'team-texas-tech',
    name: 'Texas Tech',
    shortName: 'Texas Tech',
    mascot: 'Red Raiders',
    conference: 'Big 12',
    seed: 5,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2641.png',
    primaryColor: '#CC0000',
    secondaryColor: '#000000',
    record: { wins: 22, losses: 10 },
    resume: { ...blankResume, netRanking: 19 },
  },
  {
    id: 'team-tennessee',
    name: 'Tennessee',
    shortName: 'Tennessee',
    mascot: 'Volunteers',
    conference: 'SEC',
    seed: 6,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2633.png',
    primaryColor: '#FF8200',
    secondaryColor: '#FFFFFF',
    record: { wins: 22, losses: 11 },
    resume: { ...blankResume, netRanking: 25 },
  },
  {
    id: 'team-kentucky',
    name: 'Kentucky',
    shortName: 'Kentucky',
    mascot: 'Wildcats',
    conference: 'SEC',
    seed: 7,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/96.png',
    primaryColor: '#0033A0',
    secondaryColor: '#FFFFFF',
    record: { wins: 21, losses: 13 },
    resume: { ...blankResume, netRanking: 33 },
  },
  {
    id: 'team-georgia',
    name: 'Georgia',
    shortName: 'Georgia',
    mascot: 'Bulldogs',
    conference: 'SEC',
    seed: 8,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/61.png',
    primaryColor: '#BA0C2F',
    secondaryColor: '#000000',
    record: { wins: 22, losses: 10 },
    resume: { ...blankResume, netRanking: 38 },
  },
  {
    id: 'team-saint-louis',
    name: 'Saint Louis',
    shortName: 'Saint Louis',
    mascot: 'Billikens',
    conference: 'A-10',
    seed: 9,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/139.png',
    primaryColor: '#003DA5',
    secondaryColor: '#FFFFFF',
    record: { wins: 28, losses: 5 },
    resume: { ...blankResume, netRanking: 35 },
  },
  {
    id: 'team-santa-clara',
    name: 'Santa Clara',
    shortName: 'Santa Clara',
    mascot: 'Broncos',
    conference: 'WCC',
    seed: 10,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2608.png',
    primaryColor: '#862633',
    secondaryColor: '#FFFFFF',
    record: { wins: 26, losses: 8 },
    resume: { ...blankResume, netRanking: 50 },
  },
  { // First Four
    id: 'team-miami-oh',
    name: 'Miami (OH)',
    shortName: 'Miami OH',
    mascot: 'RedHawks',
    conference: 'MAC',
    seed: 11,
    region: 'Midwest',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/193.png',
    primaryColor: '#B61E2E',
    secondaryColor: '#FFFFFF',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
  { // First Four
    id: 'team-smu',
    name: 'SMU',
    shortName: 'SMU',
    mascot: 'Mustangs',
    conference: 'ACC',
    seed: 11,
    region: 'Midwest',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2567.png',
    primaryColor: '#354CA1',
    secondaryColor: '#FFFFFF',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
  {
    id: 'team-akron',
    name: 'Akron',
    shortName: 'Akron',
    mascot: 'Zips',
    conference: 'MAC',
    seed: 12,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2006.png',
    primaryColor: '#00285E',
    secondaryColor: '#A89968',
    record: { wins: 29, losses: 5 },
    resume: { ...blankResume, netRanking: 75 },
  },
  {
    id: 'team-hofstra',
    name: 'Hofstra',
    shortName: 'Hofstra',
    mascot: 'Pride',
    conference: 'CAA',
    seed: 13,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2272.png',
    primaryColor: '#003F87',
    secondaryColor: '#FFC600',
    record: { wins: 24, losses: 10 },
    resume: { ...blankResume, netRanking: 118 },
  },
  {
    id: 'team-wright-st',
    name: 'Wright St.',
    shortName: 'Wright St.',
    mascot: 'Raiders',
    conference: 'Horizon',
    seed: 14,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2750.png',
    primaryColor: '#006400',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 11 },
    resume: { ...blankResume, netRanking: 132 },
  },
  {
    id: 'team-tennessee-st',
    name: 'Tennessee St.',
    shortName: 'Tenn. St.',
    mascot: 'Tigers',
    conference: 'OVC',
    seed: 15,
    region: 'Midwest',
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2634.png',
    primaryColor: '#002147',
    secondaryColor: '#FFFFFF',
    record: { wins: 23, losses: 9 },
    resume: { ...blankResume, netRanking: 168 },
  },
  { // First Four
    id: 'team-umbc',
    name: 'UMBC',
    shortName: 'UMBC',
    mascot: 'Retrievers',
    conference: 'AE',
    seed: 16,
    region: 'Midwest',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/2427.png',
    primaryColor: '#000000',
    secondaryColor: '#FDB913',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
  { // First Four
    id: 'team-howard',
    name: 'Howard',
    shortName: 'Howard',
    mascot: 'Bison',
    conference: 'MEAC',
    seed: 16,
    region: 'Midwest',
    playIn: true,
    logo: 'https://a.espncdn.com/i/teamlogos/ncaa/500/242.png',
    primaryColor: '#003A63',
    secondaryColor: '#E51937',
    record: { wins: 0, losses: 0 },
    resume: { ...blankResume },
  },
];

// ─── Helper functions ─────────────────────────────────────────────────────────

export const getTeamById = (id: string): Team | undefined =>
  teams.find(t => t.id === id);

export const getTeamsByRegion = (region: string): Team[] =>
  teams.filter(t => t.region?.toLowerCase() === region.toLowerCase());

export const getTeamsBySeed = (seed: number): Team[] =>
  teams.filter(t => t.seed === seed);
